const features = [
  {
    icon: 'ri-medal-line',
    title: 'Veteran Owned Business',
    description: 'Proudly veteran owned and operated, bringing military discipline, integrity, and work ethic to every project.',
  },
  {
    icon: 'ri-team-line',
    title: 'Experienced Team',
    description: 'Years of expertise in concrete pumping and stone installation with skilled professionals.',
  },
  {
    icon: 'ri-time-line',
    title: '24/7 Availability',
    description: 'Round-the-clock service to meet your project deadlines and emergency needs.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Assurance',
    description: 'Commitment to excellence with precision equipment and meticulous attention to detail.',
  },
  {
    icon: 'ri-star-line',
    title: 'Customer Satisfaction',
    description: 'Dedicated to delivering results that exceed expectations on every project.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            WHY CHOOSE LG CONCRETE PUMPING & STONE
          </h2>
          <p className="text-lg text-gray-600">Commitment to quality and precision</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`rounded-xl p-8 text-center hover:shadow-xl transition-all ${index === 0 ? 'bg-black border-2 border-yellow-500' : 'bg-white'}`}
            >
              <div className={`w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center ${index === 0 ? 'bg-yellow-500' : 'bg-yellow-500'}`}>
                <i className={`${feature.icon} text-4xl text-black`}></i>
              </div>

              <h3 className={`text-lg font-bold mb-3 min-h-[3.5rem] flex items-center justify-center ${index === 0 ? 'text-yellow-500' : 'text-black'}`}>
                {feature.title}
              </h3>

              <p className={`text-sm leading-relaxed ${index === 0 ? 'text-gray-300' : 'text-gray-600'}`}>
                {feature.description}
              </p>

              <div className={`mt-6 pt-6 border-t w-4/5 mx-auto ${index === 0 ? 'border-yellow-500/40' : 'border-gray-200'}`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;